import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  IAdvisoryExitPlanPaginatedResponse,
  getAdvisoryExitPlanPaginated,
} from "api";
import { Nullable } from "config";
import { store } from "store";

import { AdvisoryExitPlanModalMode } from "./enums";
import { IAdvisoryExitPlanModalData } from "./types";

const initialState = {
  advisoryExitPlanData: null as Nullable<
    IAdvisoryExitPlanPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    mode: AdvisoryExitPlanModalMode.VIEW,
    open: false,
    loading: false,
  } as IAdvisoryExitPlanModalData,
};

export const fetchAdvisoryExitPlanList = createAsyncThunk(
  "advisory/fetchAdvisoryExitPlanList",
  async () => {
    const filters = store.getState().FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getAdvisoryExitPlanPaginated(filters);
    return response;
  }
);

const advisoryExitPlanSlice = createSlice({
  name: "advisoryExitPlan",
  initialState,
  reducers: {
    setAdvisoryExitPlanModalData: (
      state,
      action: PayloadAction<IAdvisoryExitPlanModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeAdvisoryExitPlanModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setAdvisoryExitPlanModalLoading: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAdvisoryExitPlanList.fulfilled, (state, action) => {
      if (!action.payload) return;
      return {
        ...state,
        advisoryExitPlanData: action.payload
          ?.edges as IAdvisoryExitPlanPaginatedResponse["edges"],
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchAdvisoryExitPlanList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setAdvisoryExitPlanModalData,
  closeAdvisoryExitPlanModal,
  setAdvisoryExitPlanModalLoading,
} = advisoryExitPlanSlice.actions;

export default advisoryExitPlanSlice.reducer;
